import { RoutesMounter } from '@/types';
import { PerkIndex } from './views/PerkIndex';

export const mountPerksRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ index: true, Component: PerkIndex }],
  },
];
